<template>
  <div
    v-if="sectionId === 'crm'"
    class="w-5 h-5 text-lg flex items-center justify-center flex-shrink-0"
  >
    <HubSpotIcon />
  </div>
  <div
    v-else-if="sectionId === 'design-development'"
    class="w-5 h-5 text-lg flex items-center justify-center flex-shrink-0"
  >
    <D20Icon />
  </div>
  <!-- Remix icons in collapsed mini sidebar (design: w-5 h-5 / text-lg) -->
  <i
    v-else
    :class="[sectionIconClass, 'w-5 h-5 text-lg flex items-center justify-center flex-shrink-0']"
    aria-hidden="true"
  ></i>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import HubSpotIcon from '@/components/icons/HubSpotIcon.vue'
import D20Icon from '@/components/icons/D20Icon.vue'

const sectionIconMap: Record<string, string> = {
  'design': 'ri-palette-line',
  pdq: 'ri-printer-line',
  'order-entry': 'ri-file-list-3-line',
  'sales': 'ri-line-chart-line',
  'sales-history': 'ri-history-line',
  'product-development': 'ri-lightbulb-line',
  'project-management': 'ri-calendar-check-line',
  'install': 'ri-tools-line',
  'operations': 'ri-settings-4-line',
  'analytics': 'ri-bar-chart-box-line',
  'zoom': 'ri-customer-service-2-line',
  'admin': 'ri-admin-line',
}

const props = defineProps<{
  sectionId: string
}>()

const sectionIconClass = computed(() =>
  sectionIconMap[props.sectionId] ?? 'ri-menu-line'
)
</script>
